import {Component, Input, Output, EventEmitter} from '@angular/core';
import {BulkInfohashV2Service} from '../model/bulk-infohash-v2.service';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';
import {ToasterService} from 'angular2-toaster';
import {GeneralConstants} from '../../shared/general.constants';
import * as _ from 'lodash';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bulk-infohash-v2-results',
    templateUrl: 'bulk-infohash-v2-results.component.html',
    styleUrls: ['bulk-infohash-v2-results.component.scss']
})
export class BulkInfohashV2ResultsComponent {
    @Input() results = [];
    @Input() searchQuery = '';
    @Input() checkboxesEnabled = true;

    @Output() onSubmit = new EventEmitter();
    @Output() onClear = new EventEmitter();
    selectAll = false;
    primarySelect = false;
    private popup: any;
    private editMode = false;
    private redirectPopup: any;
    private torrentPriorityToBeShowed: any;
    private infohashToBeShowed: any;
    private discoveryTimeToBeShowed: any;
    private lastAllocatedTimeToBeShowed: any;
    private titlePriorityTimeToBeShowed: any;
    private lastSearchedTimeToBeShowed: any;
    private updatedTimeToBeShowed: any;
    private torrentAvailableToBeShowed: any;
    private humanVerifiedTimeToBeShowed: any;
    private systemVerifiedTimeToBeShowed: any;
    searchForHygeineTitle: any;
    searchByCategory: any;
    private categories = ['tv', 'movie', 'others'];

    private CATALOG_GAP_QUERY_OBJECT = {
        'infohash': '',
        'hygiene_title': '',
        'torrent_name': ''
    };
    private primaryRedirectTorrentName: any;
    private primaryRedirectParrotId: any;
    private primaryRedirectDispalyName: any;


    constructor(private infohashService: BulkInfohashV2Service, private catalogService: CatalogService,
                private toasterService: ToasterService,
                private generalConstants: GeneralConstants) {
    }

    handleResultCheckbox(result) {
        result.checked = !result.checked;
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleSubmit() {
        this.onSubmit.emit(this.results);
    }

    handleClear() {
        this.onClear.emit(this.results);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }

    handleSelectAll() {
        this.selectAll = !this.selectAll;
        this.primarySelect = !this.primarySelect;
        this.results = this.results.map((item) => {
            item.selected = this.selectAll;
            return item;
        });
    }

    handleSelected(data) {
        this.selectAll = false;
        this.primarySelect = !this.primarySelect;
        data.selected = !data.selected;
    }

    handleApprove(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        // console.log(data);
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.human_verified = true;
                item.action = 'approved';
            }
            return item;
        });
    }

    handleReject(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.human_verified = true;
                item.action = 'rejected';
            }
            return item;
        });

    }


    handleRedirect(results, $event: string[]) {
        this.selectAll = false;
        let redirectedCategory = $event[0];

        if (redirectedCategory.toLowerCase() === 'tv' || redirectedCategory.toLowerCase() === 'show') {
            redirectedCategory = 'tv';
        } else {
            redirectedCategory = redirectedCategory.toLowerCase();
        }

        const redirectedParrotId = $event[1];
        const redirectedCatalogTitle = $event[2];
        const redirectedReleaseYear = $event[3];
        const redirectedDisplayName = $event[4];
        this.primarySelect = !this.primarySelect;
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.action = 'redirect';
                item.redirected_from = item.parrot_id;
                item.parrot_id = redirectedParrotId;

                item.redirected_from_title = item.title;
                item.title = redirectedCatalogTitle;

                item.redirected_from_relese_year = item.release_year;
                item.release_year = redirectedReleaseYear;

                item.redirected_from_category = item.category;
                item.category = redirectedCategory;
                item.redirected_display_name = redirectedDisplayName;

                item.human_verified = true;
            }
            return item;
        });
    }

    handleUndo(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.results = this.results.map((item) => {
            if (item.selected && item.action) {
                item.selected = !item.selected;
                item.action = undefined;
                if (item.redirected_from && item.redirected_from !== '') {
                    item.parrot_id = item.redirected_from;
                }
                item.human_verified = false;

                if (item.redirected_from_title && item.redirected_from_title !== '') {
                    item.title = item.redirected_from_title;
                }

                if (item.redirected_from_relese_year && item.redirected_from_relese_year !== '') {
                    item.release_year = item.redirected_from_relese_year;
                }

                if (item.redirected_from_category && item.redirected_from_category !== '') {
                    item.category = item.redirected_from_category;
                }
            }
            return item;
        });
    }

    infohashDetailsPopUp(event, data) {

        this.popup = event;
        this.infohashToBeShowed = data.infohash;
        this.discoveryTimeToBeShowed = data.discovery_time;
        this.lastAllocatedTimeToBeShowed = data.last_allocated_time;
        this.lastSearchedTimeToBeShowed = data.last_searched_time;
        this.updatedTimeToBeShowed = data.updated_time;
        this.torrentAvailableToBeShowed = data.torrent_available;
        this.humanVerifiedTimeToBeShowed = data.human_verified;
        this.systemVerifiedTimeToBeShowed = data.system_verified;
        this.titlePriorityTimeToBeShowed = data.title_priority;
        this.torrentPriorityToBeShowed = data.torrent_priority;

    }

    editMetadataContent(event, data) {

        if (!data.selected) {
            data.selected = !data.selected;
        }

        this.editMode = !this.editMode;

    }

    redirectPopUp(event, data) {

        this.redirectPopup = event;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.primarySelect = true;
        this.searchForHygeineTitle = data.hygiene_title;
        this.searchByCategory = data.category;
        this.primaryRedirectTorrentName = data.torrent_name;
        this.primaryRedirectParrotId = data.parrot_id;
        this.primaryRedirectDispalyName = data.displayName;


    }

    handleCatalogGap(data) {
        this.selectAll = false;
        if (!data.selected) {
            data.selected = !data.selected;
        }
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.action = 'catalog_gap';
                item.human_verified = true;

                const catalogGapObject = this.createCatalogGapObject(item);

                this.infohashService.addToCatalogGapTable(
                    catalogGapObject,
                ).then((res) => {


                    if (res) {

                        this.toasterService.pop('info', 'Successfully Added to Catalog Gap table');

                    } else {
                        this.toasterService.pop('error', 'Failed to add to catalog gap table');
                    }
                }).catch((err) => {
                    console.error('Failed to add to catalog gap' + err.toString());
                    this.toasterService.pop('error', 'Failed to add to catalog gap table');
                });


            }
            return item;
        });

    }

    createCatalogGapObject(result) {


        const catalogGapObject = _.cloneDeep(this.CATALOG_GAP_QUERY_OBJECT);

        catalogGapObject.infohash = result.infohash;
        catalogGapObject.hygiene_title = result.hygiene_title;
        catalogGapObject.torrent_name = result.torrent_name;


        console.log(JSON.stringify(catalogGapObject));

        return JSON.stringify(catalogGapObject);

    }

    closeRedirectPopUp(event, data) {

        this.redirectPopup = event;
        this.primarySelect = false;


    }

    handleTitleSearchSelect($event: string[]) {
        this.handleRedirect(this.results, $event);
        this.closeRedirectPopUp(false, '');
    }

    changeCategory(data: any, value: any) {
        this.selectAll = false;
        // console.log(data);
        this.results = this.results.map((item) => {
            if (item.selected) {
                item.selected = !item.selected;
                item.human_verified = true;
                item.category = value;
                item.action = 'updated';
            }
            return item;
        });
        this.editMode = !this.editMode;
    }
}



// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2-results/bulk-infohash-v2-results.component.ts